import { useState, useCallback } from 'react';

interface ErrorState {
  hasError: boolean;
  error: string | null;
}

export const useErrorHandler = () => {
  const [errorState, setErrorState] = useState<ErrorState>({
    hasError: false,
    error: null
  });

  const handleError = useCallback((error: Error | string) => {
    const errorMessage = typeof error === 'string' ? error : error.message;
    setErrorState({
      hasError: true,
      error: errorMessage
    });
    
    // Log error for debugging
    console.error('Error handled:', errorMessage);
  }, []);

  const clearError = useCallback(() => {
    setErrorState({
      hasError: false,
      error: null
    });
  }, []);

  return {
    errorState,
    handleError,
    clearError
  };
};
